import React, { Component } from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { NavLink as RRNavLink, Redirect } from "react-router-dom";
import { withRouter } from "react-router-dom";
import logo from "../../assets/images/logo.svg";
import compose from "recompose/compose";
import * as authAction from "../../actions/authAction";
import { connect } from "react-redux";
import "./style.css";
import "../../containers/style.css";
import adminIcon from "../../assets/images/admin.png";
import localMapJson from "../../assets/geoJson/province.json";
import Login from "../../containers/Login";
import { ToastContainer, toast } from "react-toastify";

let localData = "1";
const province_data = [
  "koshi",
  "madhesh",
  "bagmati",
  "gandaki",
  "lumbini",
  "karnali",
  "Sudurpashchim",
];

if (JSON.parse(localStorage.getItem("user"))) {
  localData = JSON.parse(localStorage.getItem("user")).user.fiscal_year_id;
}
class MainNav extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      modal: false,
      loginModal: false,
      provinceId: null,
      provinceName: null,
    };
    this._renderUserMenu = this._renderUserMenu.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.toggleLoginModal = this.toggleLoginModal.bind(this);
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }
  toggleModal() {
    this.setState({
      modal: !this.state.modal,
    });
  }
  toggleLoginModal() {
    this.setState({
      loginModal: !this.state.loginModal,
    });
  }

  _onLogout = () => {
    const { history } = this.props;
    this.props.onLogout();
    history.push(`/`);
  };

  async componentDidMount() {
    this.setState({
      provinceId: sessionStorage.getItem("provinceId"),
    });
    if (sessionStorage.getItem("provinceId")) {
      let geoJson = localMapJson.response.find((province) => {
        return +sessionStorage.getItem("provinceId") === province.id;
      });

      this.setState({
        provinceName: geoJson && geoJson.name,
      });
    }
  }
  async componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      if (
        !sessionStorage.getItem("provinceId") &&
        this.props.location.pathname.split("/")[2] > 0
      ) {
        sessionStorage.setItem(
          "provinceId",
          this.props.location.pathname.split("/")[2]
        );
      }

      if (sessionStorage.getItem("provinceId")) {
        let geoJson = localMapJson.response.find((province) => {
          return +sessionStorage.getItem("provinceId") === province.id;
        });

        this.setState({
          provinceName: geoJson && geoJson.name,
        });
      }
    }
  }

  _openNewTab = () => {
    // let url =
    //   "https://plgsp.gov.np/sites/default/files/2021-07/Sushashan%20Book%202077-3-9%20Final%20with%20page%20for%20press.pdf";
    let url = `https://pfra.gov.np/admin/guidelines/${
      province_data[sessionStorage.getItem("provinceId") - 1]
    }.pdf`;
    window.open(url, "_blank");
  };
  _renderUserMenu() {
    const { user, history } = this.props;
    let isAdmin = false;
    let isDistrictAdmin = false;
    if (user.role === "Ministry Admin (Focal Person)") {
      isAdmin = true;
    }
    if (user.role === "OCMCM Admin") {
      isDistrictAdmin = true;
    }
    if (!this.state.provinceId) {
      // history.push('/')
    }

    return (
      <Navbar className="layout-header" color="white" light expand="md">
        <NavbarBrand
          onClick={() =>
            history.push(`/dashboard/${sessionStorage.getItem("provinceId")}`)
          }
        >
          <img src={logo} alt="logo" className="nav-logo-user" />
        </NavbarBrand>
        <div style={{ color: "#e12a2a" }}>
          <a
            onClick={() =>
              history.push(`/dashboard/${sessionStorage.getItem("provinceId")}`)
            }
          >
            <span style={{ color: "#676767", fontSize: 22 }}>
              {this.state.provinceName} <br />
            </span>
          </a>
          <span style={{ color: "#2572bc" }}>
            प्रादेशिक वित्तीय सुशासन जोखिम मूल्याङ्कन
            <br />
          </span>
          PROVINCIAL FIDUCIARY RISK ASSESSMENT
        </div>
        <NavbarToggler onClick={this.toggle} />
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="ml-auto" navbar>
            {/* <NavItem>
              <NavLink to="/dashboard" tag={RRNavLink}>ड्यासबोर्ड</NavLink>
            </NavItem> */}
            <NavItem>
              <NavLink to={"/home"} tag={RRNavLink}>
                नेपाल
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to={
                  "/" +
                  province_data[
                    parseInt(sessionStorage.getItem("provinceId")) - 1
                  ]
                }
                tag={RRNavLink}
              >
                गृह पृष्ठ
              </NavLink>
            </NavItem>
            {/* {user.role_level === 'palika' ?
              <NavItem>
                <NavLink to={"/details?gnid=" + user.gnid} tag={RRNavLink}>स्थानीय विवरण</NavLink>
              </NavItem> :
              ''
            } */}
            {user.role === "OCMCM Data Entry" ||
            user.role === "OCMCM Reviewer" ? (
              <NavItem>
                <NavLink
                  to={`/provincialEvaluation/${
                    province_data[sessionStorage.getItem("provinceId") - 1]
                  }`}
                  tag={RRNavLink}
                >
                  ड्यासबोर्ड
                </NavLink>
              </NavItem>
            ) : user.role === "OCMCM Approver" ||
              user.role === "OCMCM Admin" ? (
              <NavItem>
                <NavLink
                  to={`/dashboard/${
                    province_data[sessionStorage.getItem("provinceId") - 1]
                  }`}
                  tag={RRNavLink}
                >
                  ड्यासबोर्ड
                </NavLink>
              </NavItem>
            ) : (
              <NavItem>
                <NavLink
                  to={`/ministryEvaluation/${
                    province_data[sessionStorage.getItem("provinceId") - 1]
                  }`}
                  tag={RRNavLink}
                >
                  ड्यासबोर्ड
                </NavLink>
              </NavItem>
            )}

            <NavItem>
              <NavLink
                to={`/report/${
                  province_data[sessionStorage.getItem("provinceId") - 1]
                }`}
                tag={RRNavLink}
              >
                रिपोर्ट
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to={`/status/${
                  province_data[sessionStorage.getItem("provinceId")]
                }`}
                tag={RRNavLink}
              >
                स्थिति
              </NavLink>
            </NavItem>
            <UncontrolledDropdown nav inNavbar className="user-nav-wrapper">
              <DropdownToggle nav caret className={"nav_user"}>
                <img
                  src={adminIcon}
                  alt="user"
                  className="rounded-circle"
                ></img>
                <span className="role">{user.role}</span>
              </DropdownToggle>
              <DropdownMenu className="custom-drp" right>
                <div className="details-drp">
                  <div className="role-circle">{user.role}</div>
                  <div
                    className="user-name"
                    title={user.ministry_name || user.ocmcm_name}
                  >
                    {user.ministry_name || user.ocmcm_name}
                  </div>
                  <span className="email-circle">{user.email}</span>
                  <br />
                  <span> (आ.व. {user.fiscal_year_text})</span>
                </div>
                <DropdownItem>
                  <NavLink
                    className="dropdown-list-child"
                    to="/profile/show"
                    tag={RRNavLink}
                  >
                    प्रोफाइल
                  </NavLink>
                </DropdownItem>
                <DropdownItem divider />
                {/* <DropdownItem>
                  <NavLink className="dropdown-list-child" to="/manual" tag={RRNavLink}>म्यानुवल</NavLink>
                </DropdownItem> */}
                <DropdownItem divider />
                <DropdownItem>
                  <NavLink
                    className="dropdown-list-child"
                    to={
                      "/support/" +
                      province_data[sessionStorage.getItem("provinceId") - 1]
                    }
                    tag={RRNavLink}
                  >
                    सपोर्ट
                  </NavLink>
                </DropdownItem>
                <DropdownItem divider />
                {(isAdmin || isDistrictAdmin) && (
                  <>
                    <DropdownItem>
                      <NavLink
                        className="dropdown-list-child"
                        to={
                          "/user/" +
                          province_data[
                            sessionStorage.getItem("provinceId") - 1
                          ]
                        }
                        tag={RRNavLink}
                      >
                        प्रयोगकर्ता
                      </NavLink>
                    </DropdownItem>
                    <DropdownItem divider />
                  </>
                )}

                <DropdownItem onClick={this._openNewTab}>
                  <NavLink className="dropdown-list-child">कार्यविधि</NavLink>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={this._onLogout}>
                  <NavLink className="dropdown-list-child">लगआउट</NavLink>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Collapse>
      </Navbar>
    );
  }

  _renderGeneralMenu() {
    const { history } = this.props;
    return (
      <Navbar className="layout-header" color="white" light expand="md">
        <NavbarBrand onClick={() => history.push("/")}>
          <img src={logo} alt="logo" className="nav-logo" />
        </NavbarBrand>
        <div style={{ color: "#e12a2a" }}>
          <a onClick={() => history.push("/dashboard")}>
            <span style={{ color: "#676767", fontSize: 22 }}>
              {this.state.provinceName} <br />
            </span>
          </a>
          <span style={{ color: "#2572bc" }}>
            प्रादेशिक वित्तीय सुशासन जोखिम मूल्याङ्कन
            <br />
          </span>
          PROVINCIAL FIDUCIARY RISK ASSESSMENT
        </div>
        <NavbarToggler onClick={this.toggle} />
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="ml-auto" navbar>
            <NavItem>
              <NavLink
               to="/home" tag={RRNavLink}
               >
                नेपाल
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to={
                  "/" +
                  province_data[
                    parseInt(sessionStorage.getItem("provinceId")) - 1
                  ]
                }
                tag={RRNavLink}
              >
                गृह पृष्ठ
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to={`/report/${
                  province_data[sessionStorage.getItem("provinceId") - 1]
                }`}
                tag={RRNavLink}
              >
                रिपोर्ट
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to={`/status/${
                  province_data[sessionStorage.getItem("provinceId") - 1]
                }`}
                tag={RRNavLink}
              >
                स्थिति
              </NavLink>
            </NavItem>
            <NavItem>
              <a
                className="nav-link"
                style={{ textDecoration: "none" }}
                target="_blank"
                href={`https://pfra.gov.np/admin/guidelines/${
                  province_data[sessionStorage.getItem("provinceId") - 1]
                }.pdf`}
                // onClick={this._openNewTab}
                tag={RRNavLink}
              >
                कार्यविधि
              </a>
            </NavItem>
            {/* <NavItem>
              <NavLink to="/local/status" tag={RRNavLink}>स्थिति</NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/report" tag={RRNavLink}>रिपोर्ट</NavLink>
            </NavItem>*/}
            <NavItem>
              <NavLink
                to={`/support/${
                  province_data[sessionStorage.getItem("provinceId") - 1]
                }`}
                tag={RRNavLink}
              >
                सपोर्ट
              </NavLink>
            </NavItem>
            <NavItem>
              {/* <NavLink onClick={this.toggleModal}>कार्यविधि</NavLink> */}
              <Button
                color="primary"
                className="uni-menu-item"
                onClick={() =>
                  this.setState({
                    loginModal: true,
                  })
                }
              >
                लगइन
              </Button>
            </NavItem>
            <Modal
              style={{ height: "80vh" }}
              centered
              size="lg"
              isOpen={this.state.modal}
              toggle={this.toggleModal}
              className="menu-modal"
            >
              <ModalHeader toggle={this.toggleModal}>कार्यविधि</ModalHeader>
              <ModalBody>
                <iframe
                  style={{ width: "100%", height: "67vh" }}
                  src="https://plgsp.gov.np/sites/default/files/2021-01/LISA%20Guideline-77.pdf"
                ></iframe>
              </ModalBody>
            </Modal>
            <Login
              isOpen={this.state.loginModal}
              toggle={() => this.toggleLoginModal()}
            />
          </Nav>
        </Collapse>
      </Navbar>
    );
  }

  _renderInitialMenu() {
    const { history } = this.props;
    return (
      <Navbar className="layout-header" color="white" light expand="md">
        <NavbarBrand onClick={() => history.push("/")}>
          <img src={logo} alt="logo" className="nav-logo" />
        </NavbarBrand>
        <div style={{ color: "#e12a2a" }}>
          <span style={{ color: "#2572bc" }}>
            प्रादेशिक वित्तीय सुशासन जोखिम मूल्याङ्कन
            <br />
          </span>
          PROVINCIAL FIDUCIARY RISK ASSESSMENT
        </div>
        <NavbarToggler onClick={this.toggle} />
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="ml-auto" navbar>
            <NavItem>
              <NavLink
                to={province_data[0]}
                tag={RRNavLink}
                // className={
                //   sessionStorage.getItem("provinceId") === "1"
                //     ? "activeprovince"
                //     : ""
                // }
                onClick={() => sessionStorage.setItem("provinceId", 1)}
              >
                कोशी प्रदेश
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to={province_data[1]}
                tag={RRNavLink}
                // className={
                //   sessionStorage.getItem("provinceId") === "2"
                //     ? "activeprovince"
                //     : ""
                // }
                onClick={() => sessionStorage.setItem("provinceId", 2)}
              >
                मधेश प्रदेश
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to={province_data[2]}
                tag={RRNavLink}
                // className={
                //   sessionStorage.getItem("provinceId") === "3"
                //     ? "activeprovince"
                //     : ""
                // }
                onClick={() => sessionStorage.setItem("provinceId", 3)}
              >
                बागमती प्रदेश
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to={province_data[3]}
                tag={RRNavLink}
                // className={
                //   sessionStorage.getItem("provinceId") === "4"
                //     ? "activeprovince "
                //     : ""
                // }
                onClick={() => sessionStorage.setItem("provinceId", 4)}
              >
                गण्डकी प्रदेश
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to={province_data[4]}
                tag={RRNavLink}
                className={
                  sessionStorage.getItem("provinceId") === "5"
                    ? "activeprovince"
                    : ""
                }
                onClick={() => sessionStorage.setItem("provinceId", 5)}
              >
                लुम्बिनी प्रदेश
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to={province_data[5]}
                tag={RRNavLink}
                // className={
                //   sessionStorage.getItem("provinceId") === "6"
                //     ? "activeprovince"
                //     : ""
                // }
                onClick={() => sessionStorage.setItem("provinceId", 6)}
              >
                कर्णाली प्रदेश
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to={province_data[6]}
                tag={RRNavLink}
                // className={
                //   sessionStorage.getItem("provinceId") === "7"
                //     ? "activeprovince"
                //     : ""
                // }
                onClick={() => sessionStorage.setItem("provinceId", 7)}
              >
                सुदुरपश्चिम प्रदेश
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    );
  }

  render() {
    const { isAuthenticated, history, user } = this.props;
    // console.log("user", user)
    if (
      history.location.pathname === "/home" ||
      history.location.pathname === "/"
    ) {
      return this._renderInitialMenu();
    } else if (isAuthenticated) {
      if (user.province_id === +sessionStorage.getItem("provinceId")) {
        return this._renderUserMenu();
      } else {
        toast.error("गलत प्रदेश छनोट", {
          position: toast.POSITION.TOP_CENTER,
        });
        this.props.onLogout();
      }
      return this._renderGeneralMenu();
    } else {
      return this._renderGeneralMenu();
    }
  }
}

const mapStateToProps = ({ auth }) => ({
  initialValues: auth.login,
  user: auth.user,
  isAuthenticated: auth.isAuthenticated,
});

const mapDispatchToProps = (dispatch) => ({
  onLogout: () => {
    dispatch(authAction.logout());
  },
});

const enhance = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(MainNav);
